/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Ficha de empresa [P_E_16]
 * @export
 * @interface CompanyCompany
 */
export interface CompanyCompany {
    /**
     * 
     * @type {number}
     * @memberof CompanyCompany
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyCompany
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyCompany
     */
    nif?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyCompany
     */
    sector?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyCompany
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyCompany
     */
    subtitle?: string;
    /**
     * Este campo solo viene en GET. Contiene url final para GET de logo
     * @type {string}
     * @memberof CompanyCompany
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyCompany
     */
    web?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyCompany
     */
    location?: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyCompany
     */
    empleados?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyCompany
     */
    video?: string;
}

export function CompanyCompanyFromJSON(json: any): CompanyCompany {
    return CompanyCompanyFromJSONTyped(json, false);
}

export function CompanyCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyCompany {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'nif': !exists(json, 'nif') ? undefined : json['nif'],
        'sector': !exists(json, 'sector') ? undefined : json['sector'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'subtitle': !exists(json, 'subtitle') ? undefined : json['subtitle'],
        'logo': !exists(json, 'logo') ? undefined : json['logo'],
        'web': !exists(json, 'web') ? undefined : json['web'],
        'location': !exists(json, 'location') ? undefined : json['location'],
        'empleados': !exists(json, 'empleados') ? undefined : json['empleados'],
        'video': !exists(json, 'video') ? undefined : json['video'],
    };
}

export function CompanyCompanyToJSON(value?: CompanyCompany | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'nif': value.nif,
        'sector': value.sector,
        'text': value.text,
        'subtitle': value.subtitle,
        'logo': value.logo,
        'web': value.web,
        'location': value.location,
        'empleados': value.empleados,
        'video': value.video,
    };
}


